module.exports = __webpack_public_path__ + "static/media/LOGO_RANTAIKATA_PNG_(1)_(2).df17efd7.png";